import React, { forwardRef, ReactElement, Ref } from "react";
import CustomDialog from "../../../common/Dialog";
import { TransitionProps } from "@material-ui/core/transitions";
import Slide from "@material-ui/core/Slide";
import DriverVerificationPanel, { RejectionPayload } from "../DriverVerificationPanel";
import { makeStyles } from "@material-ui/core/styles";
import type { PortalFilterElement } from "../../redux/onBoardingSlice.types";
import { useDriverVerificationDetails } from "./useDriverVerificationDetails";

// ── Types ──────────────────────────────────────────────────────────────────

interface DriverVerificationDetailsProps {
  open: boolean;
  data: PortalFilterElement;
  onClose: () => void;
  onReject: (payload: RejectionPayload) => void;
  onApprove: () => void;
}

// ── Styles ─────────────────────────────────────────────────────────────────

const useStyles = makeStyles({
  dialogPaperPropsRoot: {
    margin: 0,
    marginLeft: "auto",
    maxHeight: "none",
    height: "100vh",
    width: 680,
  },
});

// ── Transition ─────────────────────────────────────────────────────────────

const Transition = forwardRef(function Transition(
  props: TransitionProps & { children?: ReactElement<any, any> },
  ref: Ref<unknown>
) {
  return <Slide direction="left" ref={ref} {...props} />;
});

// ── Main Component ─────────────────────────────────────────────────────────

const DriverVerificationDetails = ({
  open,
  data,
  onClose,
  onReject,
  onApprove,
}: DriverVerificationDetailsProps) => {
  const classes = useStyles();

  const { driverSections, sectionsLoading, handleReject, handleApprove } =
    useDriverVerificationDetails({ open, data, onClose, onReject, onApprove });

  const dialogPaperProps = {
    classes: { root: classes.dialogPaperPropsRoot },
    square: true,
  };

  return (
    <CustomDialog
      open={open}
      TransitionComponent={Transition}
      PaperProps={dialogPaperProps}
      title={null}
      content={
        <DriverVerificationPanel
          rowData={data}
          sections={driverSections}
          sectionsLoading={sectionsLoading}
          onClose={onClose}
          onReject={handleReject}
          onApprove={handleApprove}
        />
      }
      actions={null}
      handleClose={onClose}
      hideCloseIcon={true}
    />
  );
};

export default DriverVerificationDetails;

